import React, {useEffect, useState} from 'react';
import {FormatSubMenuItems} from './FormatSubmenuList';
import {TransformValues} from '../../utils/helper';
import {Format} from '../../ui-components/Iconpack';
import {toast} from 'react-toastify';
import Tracker from '../../lib/analytics/tracker';
import {EventNames, EventProperty} from '../../lib/analytics/events';
import {TransformationType} from '../../screens/TransformationV2/Transformation';

interface FormatSubmenuProps {
    onTransformValuesChange: (values: {format: string}) => void;
    transformationObject: TransformValues;
    addTransformation: (t: TransformationType) => void;
}

export default function FormatSubmenu({
    onTransformValuesChange,
    transformationObject,
    addTransformation,
}: FormatSubmenuProps) {
    const [selectedFormat, setSelectedFormat] = useState<string | null>(null);

    const handleFormatChange = (format: string) => {
        Tracker.trackEvent(EventNames.TRANSFORMATION_FORMAT_MODIFIED, {
            [EventProperty.Format]: format,
        });
        setSelectedFormat(format);
        onTransformValuesChange({format});
        addTransformation(TransformationType.FORMAT);
        toast.success(`Image format changed to ${format}`, {
            toastId: 'success',
        });
    };
    useEffect(() => {
        if (transformationObject.format) {
            setSelectedFormat(transformationObject.format);
        }
    }, []);

    return (
        <>
            <div className='flex items-center'>
                <div className='block cursor-pointer items-center justify-center rounded-[6px] border-[2px] border-[#4E5BA6] bg-[#717BBC] p-[12px] md:mx-[16px] md:hidden'>
                    <Format />
                </div>
                <div className='flex flex-col pl-[6px] text-[14px] font-[700] text-[#FFFFFF] md:pl-0'>
                    <span>IMAGE FORMAT</span>
                </div>
            </div>
            <div className='mt-[18px]'>
                <ul className='flex flex-col justify-center gap-4 pt-4'>
                    {FormatSubMenuItems.map((item, index) => {
                        return (
                            <div
                                key={item.value}
                                className={'cursor-pointer rounded-md'}
                                onClick={() => handleFormatChange(item.value)}>
                                <li
                                    key={item.title}
                                    className={`flex items-center justify-between rounded-[6px] border border-[#3E4784] bg-[#293056] py-[10px] pl-[10px] pr-[16px] ${selectedFormat === item.value ? 'bg-[#717BBC]' : ''}`}>
                                    <div className='flex items-center justify-center'>
                                        <input
                                            type='radio'
                                            className='h-4 w-4'
                                            checked={selectedFormat === item.value}
                                            onChange={() => handleFormatChange(item.value)}
                                        />
                                        <span className={`pl-[8px] pr-[80px] text-[10px] font-[700] text-[#FFFFFF]`}>
                                            {item.title}
                                        </span>
                                    </div>

                                    <item.icon />
                                </li>
                            </div>
                        );
                    })}
                </ul>
            </div>
        </>
    );
}
